export const companyDetails = {
  name: "Køreskolen AG",
  cvr: "31214432",
  address: "Bios Gård 6, 8600 Silkeborg",
  phone: "+45 60 69 79 99",
  email: "info@ks-ag.dk",
  facebook: "https://www.facebook.com/koereskolenag/",
  logo: "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/5a994cda-7fe1-4ed0-998f-9ba960dbe63c.png"
};

export const pagesData = {
  index: {
    page_slug: "index",
    title: "Køreskolen AG",
    meta_description: "Leder du efter en god køreskole i Silkeborg? Bliv en del af Køreskolen AG og tag dit kørekort, hurtigt og nemt. Tilmeld dig allerede i dag",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Køreskole i Silkeborg</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <div class="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-lg mb-8">
        <p class="text-red-800 font-bold text-lg mb-1">VI HAR FÅET EN NY SKOLEVOGN</p>
        <p class="text-slate-900 font-extrabold text-2xl">AUDI Q8 E-TRON</p>
      </div>
      <h2 class="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Køreskole med førstehjælp og generhvervelse af kørekort</h2>
      <p class="text-slate-600 mb-4 leading-relaxed">Skal du have taget et kørekort og leder du efter en dygtig køreskole i Silkeborg? At tage kørekort er en oplevelse man husker for livet.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Drømmen om frihed på vejene begynder her hos os. Vi forstår, at erhvervelsen af dit kørekort til personbil ikke bare er en licens til at køre, det er din nøgle til uafhængighed og eventyr.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Hos os gør vi processen både spændende og lærerig.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Vil du også huske dit kørekortsforløb som et trygt og positivt forløb, med masser af støtte og vedledning, så kan du tilmelde dig allerede i dag og blive en del af <a href="/om-os" class="text-red-600 hover:text-red-700 underline font-medium">Køreskolen AG</a> i Silkeborg.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Hos os tilpasser vi os dig og din læring, for at få dig hurtigt igennem til succes. Vi tror på at et godt og trygt kørekortforløb skaber de gode og stabile bilister på vejene fremover.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Køreskolen AG er en køreskole i Silkeborg, hvor du får noget for pengene.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Vi har flere års erfaring i branchen, og har god beliggenhed i Silkeborg.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Vores køreskole i Silkeborg is kendt blandt borgerne og er med til at give mange folk mulighed for at tage et kørekort. Vi glæder os til også at hjælpe dig.</p>
      <p class="text-slate-600 mb-8 leading-relaxed">Du kan tilmelde dig på et af holdene og finde flere informationer under <a href="/holdstart" class="text-red-600 hover:text-red-700 underline font-medium">holdstart</a>.</p>
      
      <div class="bg-slate-50 p-8 rounded-xl border border-slate-200 mb-8">
        <h3 class="text-xl font-bold text-slate-800 mb-3">Kontakt os i dag</h3>
        <p class="text-slate-600 mb-4">Ønsker du at tage dit kørekort hos Køreskolen AG i Silkeborg, men har spørgsmål til vores holdstart eller køreskolen? Så er du meget velkommen til at kontakte os på telefon <a href="tel:60697999" class="text-red-600 hover:text-red-700 font-bold whitespace-nowrap">+45 60 69 79 99</a> eller sende os en mail på <a href="mailto:info@ks-ag.dk" class="text-red-600 hover:text-red-700 font-bold whitespace-nowrap">info@ks-ag.dk</a>.</p>
        <p class="text-slate-600">Du er også meget velkommen til at udfylde vores <a href="/kontakt" class="text-red-600 hover:text-red-700 underline font-medium">kontaktformular</a> med dit spørgsmål og vi vil vende tilbage hurtigst muligt.</p>
      </div>
      
      <blockquote class="border-l-4 border-red-600 pl-4 italic text-slate-700 my-6">
        <a href="https://www.facebook.com/koereskolenag/" target="_blank" rel="noopener noreferrer" class="text-red-600 hover:text-red-700 font-semibold">Køreskolen AG på Facebook</a>
      </blockquote>
      
      <div class="mt-8 pt-6 border-t border-slate-200">
        <h3 class="text-lg font-bold text-slate-800 mb-2">Vi er medlem af Dansk Kørelærer-Union</h3>
        <a href="https://www.dku.dk/find-koreskole/" target="_blank" rel="noopener noreferrer" class="inline-flex items-center text-red-600 hover:text-red-700 font-semibold underline">Læs mere her</a>
      </div>
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/cf421f36-f100-489f-9ee8-6fe06111e74b.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/81acd7f6-8885-4245-9545-bff817c604ed.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/86b7dd11-d045-4b03-b2ca-81aee36dc24a.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/3410097f-6c08-4059-aee2-0f17fdd0b580.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/a93cd808-ec0f-4c53-8d40-68823899cffd.jpg"
    ]
  },
  "vores-ydelser": {
    page_slug: "vores-ydelser",
    title: "Vores ydelser - Køreskolen AG",
    meta_description: "Vores ydelser Hos Køreskolen AG tilbyder vi både førstegangserhvervelse og generhvervelse af kørekort til kategori B (almindelig bil) samt rutinetimer og færdselsrelateret førstehjælpskursus.",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Vores ydelser</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <p class="text-slate-600 mb-6 leading-relaxed text-lg">Hos Køreskolen AG tilbyder vi både førstegangserhvervelse og generhvervelse af kørekort til kategori B (almindelig bil) samt rutinetimer og færdselsrelateret førstehjælpskursus. Uanset om du skal have hjælp til det ene eller det andet, stræber vi altid efter at finde den bedste løsning til netop dig. Vi har stor forståelse for, at vores elevers behov og ønsker kan variere, derfor tager vi en indledende snak med dig omkring netop dette, så vi bedst muligt kan nå i mål med at erhverve kørekortet. Hos os kan du altid regne med god service og høj kvalitet.</p>
      
      <div class="bg-slate-50 p-8 rounded-xl border border-slate-200 mb-8">
        <h3 class="text-xl font-bold text-slate-800 mb-3">Vil du vide mere?</h3>
        <p class="text-slate-600 mb-4">Finder du ikke nok informationer her på vores hjemmeside, er du altid velkommen til at kontakte os til en uforpligtende snak. Ring eller send en sms til os på telefon <a href="tel:60697999" class="text-red-600 hover:text-red-700 font-bold whitespace-nowrap">+45 60 69 79 99</a>, eller send en mail til <a href="mailto:info@ks-ag.dk" class="text-red-600 hover:text-red-700 font-bold whitespace-nowrap">info@ks-ag.dk</a>.</p>
        <p class="text-slate-600">Vi besvarer din henvendelse hurtigst muligt.</p>
      </div>
      
      <div class="mt-8">
        <a href="/foerstehjaelp" class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 transition-colors">
          Nyerer FØRSTEHJÆLP
        </a>
      </div>
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/5a994cda-7fe1-4ed0-998f-9ba960dbe63c.png",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/66ce73d5-fc9c-45e5-92a6-fcf2962431fa.jpg"
    ]
  },
  materialer: {
    page_slug: "materialer",
    title: "Materialer - Køreskolen AG",
    meta_description: "Materialer - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Materialer</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <p class="text-slate-800 font-bold text-lg mb-6">Her kan du printe nogle af de dokumenter som skal bruges til dit kørekort forløb:</p>
      
      <div class="space-y-6 mb-8">
        <div class="p-6 bg-slate-50 rounded-lg border border-slate-200">
          <h3 class="font-bold text-slate-800 mb-2">Ansøgningsblanket til alle</h3>
          <a href="https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/05669b1f-8678-4b1e-b099-f90c8ae8382e.pdf" target="_blank" rel="noopener noreferrer" class="text-red-600 hover:text-red-700 underline font-medium break-all">
            https://www.fstyr.dk/blanketter-og-ansoegninger/ansoeg-om-koerekort-p23
          </a>
        </div>
        
        <div class="p-6 bg-slate-50 rounded-lg border border-slate-200">
          <h3 class="font-bold text-slate-800 mb-2">Samtykkeerklæring til 17-årige</h3>
          <a href="https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/527781a2-a2a5-453b-8f7c-c3969eba0ecc.pdf" target="_blank" rel="noopener noreferrer" class="text-red-600 hover:text-red-700 underline font-medium break-all">
            https://www.fstyr.dk/blanketter-og-ansoegninger/samtykkeerklaering-ved-ansoegning-om-koerekort-under-18-aar
          </a>
        </div>
        
        <div class="p-6 bg-slate-50 rounded-lg border border-slate-200">
          <h3 class="font-bold text-slate-800 mb-2">Ledsagerblanket til 17-årige</h3>
          <a href="https://www.fstyr.dk/Media/638161411505068245/Ledsagerblanket%20for%20medpassagerer%20til%20f%c3%b8rer%20under%2018%20%c3%a5r.pdf" target="_blank" rel="noopener noreferrer" class="text-red-600 hover:text-red-700 underline font-medium break-all">
            https://www.fstyr.dk/blanketter-og-ansoegninger/ledsagerblanket-for-medpassagerer-til-foerer-under-18-aar
          </a>
        </div>
        
        <div class="p-6 bg-slate-50 rounded-lg border border-slate-200">
          <h3 class="font-bold text-slate-800 mb-2">Du kan betale dit prøvegebyr med dankort eller kreditkort her</h3>
          <a href="https://www.koreprovebooking.dk/" target="_blank" rel="noopener noreferrer" class="text-red-600 hover:text-red-700 underline font-medium break-all">
            www.koreprovebooking.dk
          </a>
        </div>
      </div>
      
      <div class="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-lg">
        <p class="text-red-800 font-bold text-lg mb-1">HUSK</p>
        <p class="text-slate-700 leading-relaxed">Ansøgning om kørekort (P23), lektionsplan samt pas eller kørekort <strong class="text-slate-900">SKAL</strong> medbringes både til teori- og køreprøven</p>
      </div>
    `,
    images: []
  },
  priser: {
    page_slug: "priser",
    title: "Priser - Køreskolen AG",
    meta_description: "Priser - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Priser</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <h2 class="text-2xl font-bold text-slate-800 mb-6">Se vores priser her</h2>
      
      <div class="space-y-12">
        <!-- Kategori B -->
        <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-xl md:text-2xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">Kørekort til kat. B (almindelig personbil)</h3>
          
          <div class="flex justify-between items-center bg-red-50 p-4 rounded-lg mb-6">
            <span class="font-bold text-red-900 text-lg">Lovpakken</span>
            <span class="font-extrabold text-red-600 text-xl">i alt 16.900 kr.</span>
          </div>
          
          <p class="font-bold text-slate-800 mb-3">Lovpakken indeholder:</p>
          <div class="overflow-x-auto">
            <table class="min-w-full border-collapse text-left text-sm text-slate-600 mb-6">
              <tbody>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Teorikursus med kørelærer (ubegrænset i 6 måneder)</td><td class="py-3 font-semibold text-slate-900 text-right">= 2.500 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">4 x lektioner på lukket øvelsesplads (manøvrebane) inkl. transport</td><td class="py-3 font-semibold text-slate-900 text-right">= 2.300 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">4 x lektioner på køreteknisk anlæg (glatbane) inkl. transport</td><td class="py-3 font-semibold text-slate-900 text-right">= 2.600 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">16 x kørelektioner på vej</td><td class="py-3 font-semibold text-slate-900 text-right">= 10.400 kr.</td></tr>
                <tr class="border-b border-slate-100 text-red-600"><td class="py-3 pr-4 font-bold">PAKKERABAT</td><td class="py-3 font-bold text-right">= -900 kr.</td></tr>
                <tr class="bg-slate-50 font-bold text-slate-900"><td class="py-3 px-3">I alt</td><td class="py-3 px-3 text-right">16.900 kr.</td></tr>
              </tbody>
            </table>
          </div>
          
          <p class="font-bold text-slate-800 mb-3">Tillægspriser:</p>
          <div class="overflow-x-auto">
            <table class="min-w-full border-collapse text-left text-sm text-slate-600 mb-6">
              <tbody>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Prøvegebyr til Færdselsstyrelsen (betales via www.koreprovebooking.dk)</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.600 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Færdselsrelateret førstehjælpskursus</td><td class="py-3 font-semibold text-slate-900 text-right">= 650 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Leje af skolevogn til køreprøve</td><td class="py-3 font-semibold text-slate-900 text-right">= 800 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Evt. ekstra kørelektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 650 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Lægeerklæring (betales til egen læge) ca.</td><td class="py-3 font-semibold text-slate-900 text-right">= 500 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Pasfoto (afleveres til køreskolen) ca.</td><td class="py-3 font-semibold text-slate-900 text-right">= 100 kr.</td></tr>
              </tbody>
            </table>
          </div>
          
          <div class="bg-slate-50 p-6 rounded-lg text-sm text-slate-600 space-y-3 border border-slate-100">
            <p>🎁 <strong class="text-slate-900">Betaler du lovpakke + leje af skolevogn til køreprøve indenfor 8 dage efter holdstart får du 1 x gratis kørelektion (værdi 700 kr.)</strong></p>
            <p>💳 Lovpakke + leje af skolevogn til køreprøve kan betales over 3 rater: første rate på 6.000 kr. ved holdstart & sidste rate INDEN teoriprøven.</p>
            <p>⚠️ Med mindre andet aftales, skal kørelektioner afmeldes senest dagen inden aftalt tid og inden kl. 18:00, ellers afregnes gebyr på 700 kr.</p>
            <p>🏦 Betaling foregår ved bankoverførsel til Jyske Bank <span class="font-bold text-slate-900 whitespace-nowrap">7170-2765794</span> eller ved MobilePay til <span class="font-bold text-slate-900 whitespace-nowrap">78397</span>.</p>
            <p>⏱️ 1 x lektion = 45 minutter.</p>
          </div>
        </div>
        
        <!-- Særlig køreundervisning -->
        <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-xl md:text-2xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">Særlig køreundervisning</h3>
          <p class="font-bold text-slate-800 mb-3">Lovpakken:</p>
          <div class="overflow-x-auto">
            <table class="min-w-full border-collapse text-left text-sm text-slate-600 mb-6">
              <tbody>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">8 x teorilektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.500 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">8 x kørelektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 5.200 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">1 x Leje af skolevogn til køreprøve</td><td class="py-3 font-semibold text-slate-900 text-right">= 800 kr</td></tr>
                <tr class="bg-slate-50 font-bold text-slate-900"><td class="py-3 px-3">Tillægspriser:</td><td class="py-3 px-3"></td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Prøvegebyr til Færdselsstyrelsen (betales via www.koreprovebooking.dk)</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.690 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Evt. ekstra kørelektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 650 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Pasfoto ca.</td><td class="py-3 font-semibold text-slate-900 text-right">= 100 kr</td></tr>
              </tbody>
            </table>
          </div>
          <p class="text-sm text-slate-500">Betaling foregår ved bankoverførsel til Jyske Bank <span class="font-bold text-slate-900 whitespace-nowrap">7170-2765794</span> eller ved MobilePay til <span class="font-bold text-slate-900 whitespace-nowrap">78397</span>. 1 x lektion = 45 minutter.</p>
        </div>
        
        <!-- Kontrollerende køreprøve -->
        <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-xl md:text-2xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">Kontrollerende køreprøve</h3>
          <p class="text-slate-600 mb-4">Kontrollerende Køreprøve består både af en teoretisk prøve (teoriprøve) og en praktisk prøve (køreprøve)</p>
          <p class="font-bold text-slate-800 mb-3">Pakken indeholder:</p>
          <div class="overflow-x-auto">
            <table class="min-w-full border-collapse text-left text-sm text-slate-600 mb-6">
              <tbody>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Frit teoriforløb i 3 måneder</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.500 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">2 x kørelektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.300 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">1 x leje af skolevogn til køreprøve</td><td class="py-3 font-semibold text-slate-900 text-right">= 800 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Administration</td><td class="py-3 font-semibold text-slate-900 text-right">= 600 kr</td></tr>
                <tr class="bg-slate-50 font-bold text-slate-900"><td class="py-3 px-3">Tillægspriser:</td><td class="py-3 px-3"></td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Prøvegebyr til Færdselsstyrelsen (betales via www.koreprovebooking.dk)</td><td class="py-3 font-semibold text-slate-900 text-right">= 1.690 kr.</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Evt. ekstra kørelektioner</td><td class="py-3 font-semibold text-slate-900 text-right">= 650 kr</td></tr>
                <tr class="border-b border-slate-100"><td class="py-3 pr-4">Evt. pasfoto ca.</td><td class="py-3 font-semibold text-slate-900 text-right">= 100 kr</td></tr>
              </tbody>
            </table>
          </div>
          <p class="text-sm text-slate-500">Betaling foregår ved bankoverførsel til Jyske Bank <span class="font-bold text-slate-900 whitespace-nowrap">7170-2765794</span> eller ved MobilePay til <span class="font-bold text-slate-900 whitespace-nowrap">78397</span>. 1 x lektion = 45 minutter.</p>
        </div>
        
        <!-- Rutine timer -->
        <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-xl md:text-2xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">Rutine timer</h3>
          <p class="text-slate-600 mb-2">Er det længe siden du sidst har kørt bil?</p>
          <p class="text-slate-600 mb-2">Har du fået en dårlig oplevelse i trafikken?</p>
          <p class="text-slate-600 mb-4">Føler du dig ikke tryg bag rattet længere?</p>
          <p class="text-slate-800 font-bold mb-4">Så kan Køreskolen AG hjælpe dig med at få modet tilbage igen.</p>
          
          <div class="flex justify-between items-center bg-slate-50 p-4 rounded-lg mb-4">
            <span class="font-bold text-slate-700">Pris pr. rutinetime (60 minutter)</span>
            <span class="font-extrabold text-slate-900 text-lg">800 kr.</span>
          </div>
          <p class="text-sm text-slate-500">Betaling foregår ved bankoverførsel til Jyske Bank <span class="font-bold text-slate-900 whitespace-nowrap">7170-2765794</span> eller ved MobilePay til <span class="font-bold text-slate-900 whitespace-nowrap">78397</span>.</p>
        </div>
        
        <!-- Færdselsrelateret førstehjælpskursus -->
        <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-xl md:text-2xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">Færdselsrelateret førstehjælpskursus</h3>
          <p class="text-slate-600 mb-2">Du kan tage den lovpligtige færdselsrelaterede førstehjælpskursus hos Køreskolen AG.</p>
          <p class="text-slate-600 mb-2">Førstehjælpskursus afvikles i weekenderne (1 dag).</p>
          <p class="text-slate-600 mb-4">Elever udenfor Køreskolen AG er også velkommen.</p>
          
          <div class="bg-red-50 p-4 rounded-lg text-red-900 font-semibold mb-4">
            Tilmeld dig på førstehjælpskursus med SMS på tlf. nr. <a href="tel:60697999" class="font-bold underline whitespace-nowrap">60697999</a>
          </div>
          
          <div class="flex justify-between items-center bg-slate-50 p-4 rounded-lg mb-4">
            <span class="font-bold text-slate-700">Pris</span>
            <span class="font-extrabold text-slate-900 text-lg">650 kr.</span>
          </div>
          <p class="text-sm text-slate-500">Betaling afregnes på selve kursusdagen.</p>
        </div>
      </div>
    `,
    images: []
  },
  "om-os": {
    page_slug: "om-os",
    title: "Om os - Køreskolen AG",
    meta_description: "Om os - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Om os</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <h2 class="text-2xl font-bold text-slate-800 mb-4">Køreskolen AG</h2>
      <p class="text-slate-800 font-semibold text-lg mb-4">Mit navn er Ahmet Gürel</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Jeg blev uddannet kørelærer i 2011 og har siden været med til at give kørekort til flere elever. Jeg vil også gøre mit bedste, for at få DIG til at føle dig sikker bag rattet, før du kommer til at køre alene på vejene.</p>
      <p class="text-slate-600 mb-4 leading-relaxed">Du vil have teoriundervisning i moderne lokaler og komme til at køre i nyere biler. Køreskolen AG kører</p>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
        <div class="bg-slate-50 p-6 rounded-lg border border-slate-200 text-center">
          <p class="text-red-600 font-bold text-lg mb-1">MANUELT GEAR</p>
          <p class="text-slate-800 font-extrabold text-xl">BMW X1</p>
        </div>
        <div class="bg-slate-50 p-6 rounded-lg border border-slate-200 text-center">
          <p class="text-red-600 font-bold text-lg mb-1">AUTOMAT GEAR</p>
          <p class="text-slate-800 font-extrabold text-xl">BMW X5 &amp; AUDI Q8 E-TRON</p>
        </div>
      </div>
      
      <p class="text-slate-600 mb-4 leading-relaxed">Skolevognene er spækket med udstyr og har many funktioner som hjælper dig med at færdes trygt i trafikken.</p>
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/f8c5ffea-a6e3-4425-b565-dfaf9f08e7ce.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/2ae53cec-4a41-4533-9ef2-1c4ff65d5067.jpg"
    ]
  },
  nyheder: {
    page_slug: "nyheder",
    title: "Nyheder - Køreskolen AG",
    meta_description: "Nyheder - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6 sr-only">Nyheder</h1>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
        <!-- Card 1 -->
        <div class="flex flex-col bg-white rounded-none shadow-none border-0">
          <div class="w-full h-64 overflow-hidden bg-neutral-100">
            <img src="https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/b747c943-b571-4930-a491-a6187925356b.jpg" alt="Førstehjælp" class="w-full h-full object-cover rounded-none" />
          </div>
          <div class="bg-neutral-100 p-8 flex-1 flex flex-col justify-between">
            <div>
              <h3 class="text-lg font-bold text-neutral-900 mb-2 uppercase tracking-wider">FØRSTEHJÆLP</h3>
              <p class="text-neutral-600 text-sm leading-relaxed">Færdselsrelateret førstehjælpskursus søndag d. 18.02.2024</p>
            </div>
            <div class="mt-6">
              <a href="/foerstehjaelp" class="inline-block text-xs font-bold uppercase tracking-widest text-neutral-900 hover:text-[#00D492] transition-colors">LÆS MERE →</a>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="flex flex-col bg-white rounded-none shadow-none border-0">
          <div class="w-full h-64 overflow-hidden bg-neutral-100">
            <img src="https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/a6107d8d-1e10-4c90-8231-4cf90cbbbd7d.jpg" alt="Vores ydelser" class="w-full h-full object-cover rounded-none" />
          </div>
          <div class="bg-neutral-100 p-8 flex-1 flex flex-col justify-between">
            <div>
              <h3 class="text-lg font-bold text-neutral-900 mb-2 uppercase tracking-wider">VORES YDELSER</h3>
              <p class="text-neutral-600 text-sm leading-relaxed">Vores ydelser Hos Køreskolen AG tilbyder vi både førstegangserhvervelse og generhvervelse af kørekort til kategori B (almindelig bil) samt rutinetimer og færdselsrelateret førstehjælpskursus. Uanset om du skal have hjælp til det ene eller det andet, stræber vi altid efter at finde den bedste løsning til netop dig. Vi har stor forståelse for, at vores elevers behov og ønsker kan variere, […]</p>
            </div>
            <div class="mt-6">
              <a href="/vores-ydelser" class="inline-block text-xs font-bold uppercase tracking-widest text-neutral-900 hover:text-[#00D492] transition-colors">LÆS MERE →</a>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col items-center justify-center text-center space-y-2 py-16 border-t border-neutral-200">
        <p class="text-sm font-bold tracking-widest text-neutral-500 uppercase">---> NY ADRESSE <---</p>
        <p class="text-lg font-bold text-neutral-900 uppercase">VI ER FLYTTET IND TIL</p>
        <p class="text-2xl font-black text-neutral-900 uppercase">BIOS GÅRD 6, 8600 SILKEBORG</p>
      </div>
      <hr class="border-t border-neutral-200 w-full" />
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/b747c943-b571-4930-a491-a6187925356b.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/a6107d8d-1e10-4c90-8231-4cf90cbbbd7d.jpg"
    ]
  },
  kontakt: {
    page_slug: "kontakt",
    title: "Kontakt - Køreskolen AG",
    meta_description: "Kontakt - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Kontakt</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      <h2 class="text-2xl font-bold text-slate-800 mb-4">Kontakt os</h2>
      <h3 class="text-lg font-semibold text-slate-600 mb-6">Send os en besked og vi vil vende tilbage hurtigst muligt</h3>
    `,
    images: []
  },
  holdstart: {
    page_slug: "holdstart",
    title: "Holdstart - Køreskolen AG",
    meta_description: "Holdstart - Køreskolen AG",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">Holdstart</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      
      <div class="space-y-4 text-slate-600 mb-8 leading-relaxed">
        <p>⏱️ Du kan tidligst begynde med at tage kørekort 3 måneder før du fylder 17 år.</p>
        <p>📝 Er du under 18 år skal du have dine forældre til at udfylde en samtykkeerklæring.</p>
        <p>📎 Du kan finde samtykkeerklæring under <a href="/materialer" class="text-red-600 hover:text-red-700 underline font-medium">Materialer</a></p>
        <p class="bg-slate-50 p-4 rounded-lg border border-slate-200 text-slate-700 font-medium">
          💡 <strong class="text-slate-900">OBS:</strong> ved tilmelding til holdstart betales depositum på 2.000 kr. til Køreskolen AGs MobilePay nr. <span class="font-bold text-slate-900">78397</span>
        </p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-lg font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100 flex items-center gap-2">
            <span class="h-2 w-2 rounded-full bg-red-600"></span>
            Mandagshold – teori kl. 16.30
          </h3>
          <ul class="space-y-2 text-slate-600">
            <li class="flex items-center gap-2">📅 Mandag d. 4 maj 2026</li>
            <li class="flex items-center gap-2">📅 TORSDAG d. 10 august 2026</li>
            <li class="flex items-center gap-2">📅 Mandag d. 5 oktober 2026</li>
            <li class="flex items-center gap-2">📅 Mandag d. 7 december 2026</li>
          </ul>
        </div>
        
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="text-lg font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100 flex items-center gap-2">
            <span class="h-2 w-2 rounded-full bg-red-600"></span>
            Tirsdagshold – teori kl. 16.30
          </h3>
          <ul class="space-y-2 text-slate-600">
            <li class="flex items-center gap-2">📅 Tirsdag d. 2 juni 2026</li>
            <li class="flex items-center gap-2">📅 Tirsdag d. 1 september 2026</li>
            <li class="flex items-center gap-2">📅 Tirsdag d. 3 november 2026</li>
            <li class="flex items-center gap-2">📅 Tirsdag d. 5 januar 2027</li>
          </ul>
        </div>
      </div>
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/81acd7f6-8885-4245-9545-bff817c604ed.jpg"
    ]
  },
  foerstehjaelp: {
    page_slug: "foerstehjaelp",
    title: "FØRSTEHJÆLP - Køreskolen AG",
    meta_description: "Færdselsrelateret førstehjælpskursus søndag d. 18.02.2024",
    content_html: `
      <h1 class="text-3xl md:text-5xl font-bold text-slate-900 mb-6">FØRSTEHJÆLP</h1>
      <hr class="border-red-600 border-t-2 w-20 mb-8" />
      
      <div class="bg-white p-6 md:p-8 rounded-xl border border-slate-200 shadow-sm mb-8 max-w-2xl">
        <h2 class="text-2xl font-bold text-slate-900 mb-4">FØRSTEHJÆLP</h2>
        <div class="bg-red-50 p-6 rounded-lg border border-red-100 mb-6">
          <p class="text-red-900 font-extrabold text-xl mb-1">Færdselsrelateret førstehjælpskursus</p>
          <p class="text-slate-800 font-bold text-lg">Søndag d. 18.02.2024 kl. 8:30</p>
        </div>
        
        <p class="text-slate-600 mb-6">Du kan tilmelde dig kurset ved at sende en SMS med dit navn til <a href="tel:60697999" class="text-red-600 hover:text-red-700 font-bold whitespace-nowrap">+45 60 69 79 99</a>.</p>
        
        <div class="pt-4 border-t border-slate-100">
          <a href="/vores-ydelser" class="text-red-600 hover:text-red-700 font-bold underline">
            Ændre Vores ydelser
          </a>
        </div>
      </div>
    `,
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/5a994cda-7fe1-4ed0-998f-9ba960dbe63c.png",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/b747c943-b571-4930-a491-a6187925356b.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/8463530b-3893-408d-8125-7f47db92684d.jpg"
    ]
  }
};

export const galleriesData = {
  "om-os": {
    slug_reference: "om-os",
    title: "Vores biler og lokaler",
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/f8c5ffea-a6e3-4425-b565-dfaf9f08e7ce.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/2ae53cec-4a41-4533-9ef2-1c4ff65d5067.jpg"
    ]
  },
  index: {
    slug_reference: "index",
    title: "Køreskolen AG Billeder",
    images: [
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/cf421f36-f100-489f-9ee8-6fe06111e74b.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/81acd7f6-8885-4245-9545-bff817c604ed.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/86b7dd11-d045-4b03-b2ca-81aee36dc24a.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/3410097f-6c08-4059-aee2-0f17fdd0b580.jpg",
      "https://assets.auxodev.dk/assets/354bdcac-d302-42dd-b3d6-dafad7605e7e/a93cd808-ec0f-4c53-8d40-68823899cffd.jpg"
    ]
  }
};
